import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { MessageService } from 'src/app/core';
import {
  getImageUploadValidationError,
  IMAGE_UPLOAD_ACCEPT
} from 'src/app/core/constants/image-upload.constant';
import { ImageCropperModalComponent } from '../image-cropper-modal/image-cropper-modal.component';
@Component({
  selector: 'app-ls-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LSFileUploadComponent implements OnInit , OnChanges {
  @ViewChild('fileInput') fileInput!:ElementRef;
  @Input() heading:string = '';
  @Input() imgPath:string = '';
  @Input() imgType:string = '';
  @Input() isEditPermission:boolean = true;
  /** When true, opens the image cropper modal before emitting the selected file */
  @Input() enableImageCropper = false;
  /** Crop aspect ratio (e.g. 1 for square favicon); used when maintainAspectRatio is true */
  @Input() cropAspectRatio: number | null = null;
  @Input() cropMaintainAspectRatio = false;
  @Input() cropRound = false;
  @Input() cropperTitle = '';
  @Input() cropTargetWidth = 0;
  @Input() cropTargetHeight = 0;
  /** Enables square (250×250) / rectangle logo shape toggle inside the cropper only. */
  @Input() cropAllowLogoShapeSwitch = false;
  /** Default editor canvas tone when the cropper opens */
  @Input() cropCanvasMode: 'light' | 'dark' = 'light';
  @Output() fileSelected:EventEmitter<any> = new EventEmitter();
  @Output() fileReset:EventEmitter<any> = new EventEmitter();
  uniqueID:string  = _.uniqueId('file_');
  readonly acceptedImageAccept = IMAGE_UPLOAD_ACCEPT;

  constructor(
    private translateService: TranslateService,
    private modalService: NgbModal,
    private msgService: MessageService
  ) {
    this.translateService.setDefaultLang('en');
    this.translateService.use(localStorage.getItem('Selected_Language') || 'en'); } 
  ngOnChanges(changes:SimpleChanges):void{
    const img = changes['imgPath'];
    if(img &&  (img.currentValue!= img.previousValue)){
      if(this.imgType == 'Profile'){
        this.imgPath = img.currentValue ? img.currentValue : '../assets/images/icons/default-user.png' ;
      }else if(this.imgType == 'Favicon'){
        this.imgPath = img.currentValue ? img.currentValue : '../assets/images/icons/default-favicon.png' ;
      }else{
        this.imgPath = img.currentValue ? img.currentValue : '../assets/images/icons/default.png' ;
      }
    }

    const isPermission = changes['isEditPermission'];
    if(isPermission &&  (isPermission.currentValue!= isPermission.previousValue)){
      this.isEditPermission = isPermission.currentValue;
    }
  }

  ngOnInit(): void {

}

  onUploadBtnClick(){
    this.fileInput.nativeElement.click();
  }
  // on file upload
  onFileChange(event:any) {
    if(event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const validationError = getImageUploadValidationError(file);

      if (validationError) {
        this.msgService.showError(this.translateService.instant(validationError));
        this.fileInput.nativeElement.value = '';
        return;
      }

      if (this.enableImageCropper) {
        this.openImageCropper(file);
      } else {
        this.fileSelected.emit(file);
      }
    }
    this.fileInput.nativeElement.value = '';
  }

  /** Opens the reusable cropper modal; emits the cropped File on confirm */
  private openImageCropper(file: File): void {
    const modalRef = this.modalService.open(ImageCropperModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'xl',
      backdrop: 'static',
      windowClass: 'image-cropper-modal-window',
      modalDialogClass: 'image-cropper-modal-dialog'
    });

    modalRef.componentInstance.title = this.cropperTitle || this.heading;
    modalRef.componentInstance.aspectRatio = this.cropAspectRatio;
    modalRef.componentInstance.maintainAspectRatio = this.cropMaintainAspectRatio;
    modalRef.componentInstance.roundCropper = this.cropRound;
    modalRef.componentInstance.targetWidth = this.cropTargetWidth;
    modalRef.componentInstance.targetHeight = this.cropTargetHeight;
    modalRef.componentInstance.allowLogoShapeSwitch = this.cropAllowLogoShapeSwitch;
    modalRef.componentInstance.defaultCanvasMode = this.cropCanvasMode;
    modalRef.componentInstance.imageFile = file;

    modalRef.result
      .then((croppedFile: File) => {
        if (croppedFile) {
          this.fileSelected.emit(croppedFile);
        }
      })
      .catch(() => {});
  }
  // on file reset
  onFileReset() {
    this.fileReset.emit(true);
    this.fileInput.nativeElement.value = '';
  }


  ngOnDestroy(): void {}
}